import React from 'react'
import './Games.css'

const Games = () => {
  const games = [
    {
      id: 11,
      title: 'Guess Their Answer',
      platforms: 'Android, iOS',
      info: '100M+ downloads',
      image: '/assets/images/games/guess-their-answer.jpg',
      icon: '/assets/images/icons/guess-their-answer.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.qoni.guesstheiranswer'
    },
    {
      id: 8,
      title: 'Fall Golf',
      platforms: 'Fortnite',
      info: '1M+ players',
      image: '/assets/images/games/fall-golf.jpg',
      link: 'https://www.fortnite.com/@loomio/4373-9217-8383'
    },
    {
      id: 18,
      title: 'Hangman Go!',
      platforms: 'Android, iOS',
      image: '/assets/images/games/hangman-go.jpg',
      icon: '/assets/images/icons/hangman-go.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.loomio.hangmango'
    },
    {
      id: 19,
      title: 'Block Roguelike',
      platforms: 'Fortnite',
      image: '/assets/images/games/block-roguelike.jpg',
      link: 'https://www.fortnite.com/@loomio/9798-3463-3051'
    },
    {
      id: 20,
      title: 'Epic Mayhem',
      platforms: 'Android',
      image: '/assets/images/games/epic-mayhem.jpg',
      icon: '/assets/images/icons/epic-mayhem.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.loomio.epicmayhem'
    },
    {
      id: 13,
      title: 'Loomi Party',
      platforms: 'Android',
      image: '/assets/images/games/loomi-party.jpg',
      icon: '/assets/images/icons/loomi-party.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.bluecactus.loomiland'
    },
    {
      id: 4,
      title: 'Guess What',
      platforms: 'Android',
      image: '/assets/images/games/guess-what.jpg',
      icon: '/assets/images/icons/guess-what.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.loomio.guesswhat'
    },
    {
      id: 2,
      title: 'Where Is The Skin',
      platforms: 'Fortnite',
      image: '/assets/images/games/where-is-the-skin.jpg',
      link: 'https://www.fortnite.com/@loomio/0313-8675-9813'
    },
    {
      id: 3,
      title: 'Police Detective',
      platforms: 'Android',
      image: '/assets/images/games/police-detective.jpg',
      icon: '/assets/images/icons/police-detective.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.pierre.policedetective'
    },
    {
      id: 5,
      title: 'Tower Box Fight',
      platforms: 'Fortnite',
      image: '/assets/images/games/tower-box-fight.jpg',
      link: 'https://www.fortnite.com/@loomio/5860-1671-6952'
    },
    {
      id: 6,
      title: 'Word Go',
      platforms: 'Android',
      image: '/assets/images/games/word-go.jpg',
      icon: '/assets/images/icons/word-go.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.loomio.wordgo'
    },
    {
      id: 1,
      title: 'Watermelon Merge',
      platforms: 'Android',
      image: '/assets/images/games/watermelon-merge.jpg',
      icon: '/assets/images/icons/watermelon-merge.jpg',
      link: '#'
    },
    {
      id: 9,
      title: 'Rescue Island Puzzle',
      platforms: 'Android',
      image: '/assets/images/games/rescue-island-puzzle.jpg',
      icon: '/assets/images/icons/rescue-island-puzzle.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.bluecactus.rescueislandpuzzle'
    },
    {
      id: 10,
      title: 'Football Rush',
      platforms: 'Fortnite',
      image: '/assets/images/games/football-rush.jpg',
      link: 'https://www.fortnite.com/@loomio/0498-0001-9815'
    },
    {
      id: 12,
      title: 'Eggshot',
      platforms: 'Fortnite',
      image: '/assets/images/games/eggshot.jpg',
      link: 'https://www.fortnite.com/@loomio/6593-4086-9159'
    },
    {
      id: 14,
      title: 'Propnite',
      platforms: 'Fortnite',
      image: '/assets/images/games/propnite.jpg',
      link: 'https://www.fortnite.com/@loomio/9323-6599-5944'
    },
    {
      id: 15,
      title: 'Sniper Vs Thief',
      platforms: 'Fortnite',
      image: '/assets/images/games/sniper-vs-thief.jpg',
      link: 'https://www.fortnite.com/@loomio/2415-4353-5752'
    },
    {
      id: 16,
      title: 'Basketball Trickshot Parkour',
      platforms: 'Fortnite',
      image: '/assets/images/games/basketball-trickshot-parkour.jpg',
      link: 'https://www.fortnite.com/@loomio/8321-2223-9566'
    },
    {
      id: 17,
      title: 'Parkour',
      platforms: 'Fortnite',
      image: '/assets/images/games/parkour.jpg',
      link: 'https://www.fortnite.com/@loomio/0714-3876-3646'
    },
    {
      id: 21,
      title: 'City Puzzles',
      platforms: 'Android',
      image: '/assets/images/games/city-puzzles.jpg',
      icon: '/assets/images/icons/city-puzzles.jpg',
      link: '#'
    },
    {
      id: 22,
      title: 'Brainrot IO',
      platforms: 'Fortnite',
      image: '/assets/images/games/brainrot-io.jpg',
      link: 'https://www.fortnite.com/@loomio/0532-3640-7380'
    },
    {
      id: 23,
      title: 'Gacha Roguelike',
      platforms: 'Fortnite',
      image: '/assets/images/games/gacha-roguelike.jpg',
      link: 'https://www.fortnite.com/@loomio/0443-5158-0739'
    },
    {
      id: 24,
      title: 'Duel Swipe',
      platforms: 'Android',
      image: '/assets/images/games/duel-swipe.jpg',
      icon: '/assets/images/icons/duel-swipe.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.bluecactus.duelswipe'
    },
    {
      id: 7,
      title: 'Wild Cards Run',
      platforms: 'Android',
      image: '/assets/images/games/wild-cards-run.jpg',
      icon: '/assets/images/icons/wild-card-go.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.pierre.wildcardsrun'
    },
    // {
    //   id: 25,
    //   title: 'Jurassic Arena',
    //   platforms: 'Fortnite',
    //   image: '/assets/images/games/jurassic-arena.jpg',
    //   link: 'https://www.fortnite.com/@loomio/6651-4872-3045'
    // },
    {
      id: 26,
      title: 'Feed The Dragon',
      platforms: 'Fortnite',
      image: '/assets/images/games/feed-the-dragon.jpg',
      link: 'https://www.fortnite.com/@loomio/0323-2292-2989'
    },
    {
      id: 27,
      title: 'Bridge Wars',
      platforms: 'Fortnite',
      image: '/assets/images/games/bridge-wars.jpg',
      link: 'https://www.fortnite.com/@loomio/1765-8951-4834'
    }
  ]

  return (
    <main className="games-page">
      <section className="games-section pattern-bg">
        <div className="container">
          <div className="games-grid">
            {games.map((game) => (
              <a key={game.id} href={game.link} className="game-card">
                <img src={game.image} alt={game.title} className="game-image" />
                {game.icon && (
                  <div className="game-icon-overlay">
                    <img src={game.icon} alt={game.title} />
                  </div>
                )}
                <div className="game-overlay">
                  <div className="game-content">
                    <h3>{game.title}</h3>
                    <div className="game-meta">
                      <span>{game.platforms}</span>
                      <span>{game.info}</span>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </main>
  )
}

export default Games
